export default __webpack_public_path__ + "static/media/EMprint Light.5138b2c2.eot";